var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75886 8.9662C7.23363 7.01706 10.2168 5.73194 11.7084 5.11109C15.9721 3.33821 16.857 3.0303 17.4349 3.01987C17.562 3.01783 17.845 3.04924 18.0297 3.19852C18.1831 3.32442 18.2263 3.49468 18.2479 3.61422C18.2671 3.73365 18.2934 4.00583 18.2719 4.21829C18.0417 6.64512 17.0417 12.5343 16.5333 15.2524C16.3199 16.4026 15.8954 16.7882 15.4853 16.8258C14.5933 16.9078 13.917 16.2368 13.0537 15.6711C11.7036 14.7855 10.941 14.2345 9.62928 13.3705C8.11371 12.3719 9.09691 11.823 9.96021 10.9261C10.1856 10.6914 14.1136 7.11946 14.188 6.79548C14.1976 6.75495 14.2072 6.60387 14.116 6.52426C14.0273 6.4444 13.8954 6.47174 13.7995 6.49332C13.6628 6.52402 11.507 7.95038 7.32475 10.7722C6.71325 11.1928 6.1593 11.3978 5.6605 11.387C5.11375 11.3753 4.05861 11.0772 3.27444 10.8225C2.31522 10.5101 1.55024 10.3448 1.61739 9.81415C1.65096 9.53789 2.03225 9.25516 2.75886 8.9662Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.10992c213c41498f867057b0cb6056d7.svg";
export { ForwardRef as ReactComponent };